<script>
import Layout from "@/router/layouts/franchise";
import { api } from "@/state/services";

export default {
  locales: {
    pt: {
      Points: "Pontos",
      Inventory: "Inventário",
      Orders: "Pedidos",
      "No records found.": "Nenhum registro encontrado.",
      Order: "Pedido",
      Date: "Data",
      Username: "Usuário",
      Name: "Nome",
      Total: "Total",
      Status: "Status",
      View: "Ver",
    },
    es: {
      Points: "Puntos",
      Inventory: "Inventario",
      Orders: "Pedidos",
      "No records found.": "No se encontraron registros.",
      Order: "Pedido",
      Date: "Fecha",
      Username: "Nombre de Usuario",
      Name: "Nombre",
      Total: "Total",
      Status: "Estado",
      View: "Ver",
    },
  },
  components: {
    Layout,
  },
  data() {
    return {
      orders: [],
    };
  },
  methods: {
    getOrders() {
      api
        .get("franchise/points/orders")
        .then((response) => {
          if (response.data.status == "success") {
            this.orders = response.data.list;
          }
        })
        .catch((error) => {
          if (error) {
            this.orders = [];
          }
        });
    },
  },
  mounted() {
    this.getOrders();
  },
};
</script>

<template>
  <Layout>
    <div class="row">
      <div class="col-12">
        <div class="page-title-box d-flex justify-content-between">
          <h4 class="mb-0 font-size-18">{{ t("Points") }} › {{ t("Orders") }}</h4>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="table-responsive">
              <vcl-list v-if="!orders" class="col-lg-6"></vcl-list>
              <template v-else-if="orders.length == 0">
                {{ t("No records found.") }}
              </template>
              <table v-else class="table table-nowrap">
                <thead class="thead-light">
                  <tr>
                    <th>{{ t("Order") }}</th>
                    <th>{{ t("Date") }}</th>
                    <th>{{ t("Username") }}</th>
                    <th>{{ t("Name") }}</th>
                    <th>{{ t("Total") }}</th>
                    <th>{{ t("Status") }}</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(order, index) in orders" :key="index">
                    <td class="align-middle">{{ order.id }}</td>
                    <td class="align-middle">{{ order.date }}</td>
                    <td class="align-middle">{{ order.username }}</td>
                    <td class="align-middle">{{ order.name }}</td>
                    <td class="align-middle">{{ order.total | currency }}</td>
                    <td class="align-middle">{{ order.status }}</td>
                    <td class="text-right">
                      <router-link :to="'/franchise/points/orders/' + order.id" class="btn btn-default btn-sm btn-rounded">
                        {{ t("View") }}
                        <i class="mdi mdi-arrow-right ml-1"></i>
                      </router-link>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
